// Wat een taak nog mist om "uitgewerkt" te zijn (ontwerp Taakbeheer, 23/10/2026): een schatting in Clockify, een
// eigenaar, en gezette datums (start en deadline niet op dezelfde dag, zoals Planner ze laat staan bij het aanmaken).
// Een omschrijving telt niet mee: sommige taken spreken voor zich (Rens, 26/10/2026). Een geparkeerde taak (label
// On hold of Waiting) hoeft nog geen eigenaar en geen schatting te hebben; die horen erbij zodra ze weer actief wordt,
// bijvoorbeeld op To do (Rens, 26/10/2026). De chips in de lijst, de filter "Nog uit te werken" en de regel bovenaan
// het taakvenster komen hieruit.
import type { TaskHours } from "./api-clockify";
import { categoryOf } from "./planning";
import type { Task } from "./types";

export type Missing = "schatting" | "eigenaar" | "datums";
export const MISSING_TEXT: Record<Missing, string> = { schatting: "schatting", eigenaar: "eigenaar", datums: "datums" };
export const MISSING_LONG: Record<Missing, string> = { schatting: "de schatting", eigenaar: "een eigenaar", datums: "de datums" };

/**
 * hours: de uren van de taak uit Clockify; clockify: Clockify is gekoppeld en gelezen (anders telt de schatting niet
 * mee). Een taak die bewust zonder Clockify-taak staat, mist geen schatting. Een geparkeerde taak mist geen schatting
 * en geen eigenaar: alleen haar datums tellen.
 */
export function missing(t: Task, hours: TaskHours | undefined, clockify: boolean): Missing[] {
  const m: Missing[] = [];
  const parked = categoryOf(t.labels) === "geparkeerd";
  if (!parked && clockify && !hours?.none && hours?.estimate == null) m.push("schatting");
  if (!parked && !t.owners.length) m.push("eigenaar");
  if (t.start === t.end) m.push("datums");
  return m;
}

/** "de schatting, een eigenaar en de datums" */
export const missingSentence = (m: Missing[]) => m.map((k) => MISSING_LONG[k]).reduce((s, x, i) => s + (i === 0 ? "" : i === m.length - 1 ? " en " : ", ") + x, "");
